// eslint-disable-next-line import/prefer-default-export
export const AWS_AMPLIFY = {
  Auth: {
    identityPoolId: 'us-east-2:8b3cc95f-7873-4c2f-9f9c-93d6846bde0a',
    region: 'us-east-2',
    userPoolId: 'us-east-2_fpYy0c3Pi',
    userPoolWebClientId: '5t42ci658c84mhsj4flp4tibrn',
    mandatorySignIn: true,
    cookieStorage: {
      domain: process.env.AUTH_DOMAIN,
      path: '/',
      expires: 5,
      secure: false,
    },
  },
};

export const COOKIE_OPTIONS = {
  domain: process.env.AUTH_DOMAIN,
  path: '/',
  secure: false,
};
